import { Menu, Portal, Text } from '@chakra-ui/react'
import { ProductCategory, ProductCategoryType } from '@leid/api-products'

import theme from 'styles/theme'

import CategoryMenuItemLink from '../CategoryLink'
import { getCategoryName } from '../utils/categories'

type Props = {
  title: string
  category?: ProductCategory
  allCategories: ProductCategory[]
  closeMenu: () => void
}

const FullCategoryMenuItem = ({ title, category, allCategories, closeMenu }: Props): JSX.Element => {
  const childrenCategories = allCategories.filter(
    (s) =>
      s.parentCategoryId === (category ? category.id : undefined) &&
      (s.type === ProductCategoryType.PRODUCTS || s.parentCategoryId !== undefined),
  )

  if (!category) {
    return (
      <Menu.Content
        zIndex="modal"
        colorPalette="leidTheme"
        borderRadius={theme.token('borderRadius.big')}
        border="1px solid {colors.green.a50}"
      >
        <Menu.ItemGroup
          style={{
            padding: '20px',
          }}
        >
          <Text fontSize={{ base: 'lg', lg: 'md' }} fontWeight={'bold'}>
            {title}
          </Text>
        </Menu.ItemGroup>

        {childrenCategories.map((cat) => (
          <FullCategoryMenuItem
            key={cat.id}
            category={cat}
            allCategories={allCategories}
            closeMenu={closeMenu}
            title={title}
          />
        ))}
      </Menu.Content>
    )
  }

  if (childrenCategories.length === 0) {
    return (
      <Menu.Item key={category.id} asChild value={category.id.toString()} onClick={closeMenu}>
        <CategoryMenuItemLink category={category} allCategories={allCategories} onClick={closeMenu} />
      </Menu.Item>
    )
  }

  return (
    <Menu.Root size="md" positioning={{ gutter: 2 }}>
      <Menu.TriggerItem onClick={closeMenu}>
        <CategoryMenuItemLink hasChildren category={category} allCategories={allCategories} onClick={closeMenu} />
      </Menu.TriggerItem>
      <Portal>
        <Menu.Positioner>
          <Menu.Content
            zIndex="modal"
            borderRadius={theme.token('borderRadius.big')}
            border="1px solid {colors.green.a50}"
          >
            <Menu.ItemGroup
              style={{
                padding: '20px',
              }}
            >
              <Text fontSize={{ base: 'lg', lg: 'md' }} fontWeight={'bold'}>
                {getCategoryName(category)}
              </Text>
            </Menu.ItemGroup>

            {childrenCategories.map((cat) => (
              <FullCategoryMenuItem
                key={cat.id}
                category={cat}
                allCategories={allCategories}
                closeMenu={closeMenu}
                title={title}
              />
            ))}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  )
}

export default FullCategoryMenuItem
